import { render, staticRenderFns } from "./CuentasBancarias.vue?vue&type=template&id=72400d41&lang=pug"
import script from "./CuentasBancarias.vue?vue&type=script&lang=js"
export * from "./CuentasBancarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports